import React from "react";
import { Link } from "react-router-dom";
import logo from "../../../images/logo/logo-combined.png";

const Navbar = () => {
  return (
    <div  className="border-bottom">
      <nav class="navbar navbar-expand-lg navbar-light bg-white">
        <div class="container-fluid ms-5">
          <Link class="navbar-brand" to="/search">
            <img src={logo} alt="" width="160px" />
          </Link>
         
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
